// extracted by mini-css-extract-plugin
export default {"root":"wVaUBFajSntYc87FRwaE"};